import { Box, Flex } from '@chakra-ui/react';
import { FunctionComponent, ReactNode } from 'react';
import { StepHeader, StepHeaderProps } from './StepHeader';

type Props = Omit<StepHeaderProps, 'isBackEnabled'> & {
  isBackEnabled?: boolean;
  children: ReactNode;
};

/** Frame for every wave step page: the shared step header and a full-height content area. */
export const StepPageLayout: FunctionComponent<Props> = ({ isBackEnabled = true, children, ...headerProps }) => (
  <Flex direction="column" h="100%" w="100%" overflow="hidden" bg="marketcast.base.background">
    <StepHeader {...headerProps} isBackEnabled={isBackEnabled} />
    {/* minH={0} lets the page's own scroll areas shrink instead of growing past the viewport. */}
    <Box as="main" flex={1} minH={0}>
      {children}
    </Box>
  </Flex>
);
